<template>
    <div class="adminUserList">
        <Breadcumb title="Plan d'actions" :breadcumb-data="breadcumbData">
        </Breadcumb>
       
    </div>
</template>
<script>
    import { mapState } from 'vuex';
    import Breadcumb from '../components/breadcumb'
    import {GET_REPORT_SURVEY_REQUEST, GET_RESULT_REQUEST} from "../_store/administration/result/actiontypes";
    import slugify from 'slugify'

    export default {
        name: 'adminUserList',
        components: { Breadcumb, },
        computed: mapState({ user: state => state.user.user }),
        mounted() {
            this.breadcumbData = [
                { text: this.$t('welcome'), href: '/dashboard/' },
                { text: "Plan d'actions", active: true },
            ];
        },
        data() {
            return {
                breadcumbData: [],
                fields: [],
                reportsData: [],
                currentPage: 1
            };
        },
        layout(context) {
            return 'layout';
        },
        methods: {
        },
    };
</script>
